import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';
import {
  RESTRICTION_TYPE_NONE,
  RESTRICTION_TYPES,
  type RestrictionAppliedContextsType,
} from 'lumen/utils/constants/channel-pricing-constants';

// SMART DISTRIBUTION TODO: Maybe this type should be in another folder?
//  - lumen/app/types
//  - lumen/types
//  - lumen/utils/constants/channel-pricing-constants
export type RestrictionValue = {
  appliedContext?: RestrictionAppliedContextsType;
  autopilotEnabled?: boolean;
  type: (typeof RESTRICTION_TYPES)[keyof typeof RESTRICTION_TYPES];
  value: number;
};

type RestrictionFormat = { formattedValue: string; valueId: string };

/**
 * Function that holds the logic to format the restriction values that are present in the
 * restrictions & restriction-recommendation models.
 *
 * Notes:
 * - SMART DISTRIBUTION TODO: More documentation of all this logic is needed!
 * - MIN_LOS 1, means 'no restriction applied' which in the UI could be rendered as "Open"
 * - Type CLOSED; value:0 also means Open restriction/recommendation
 *
 * @param restrictionValue
 * @param intl
 */
export function formatRestrictionValueUtility(
  restrictionValue: RestrictionValue,
  intl: Services['intl'],
): RestrictionFormat {
  const { type, value } = restrictionValue;

  if (type === RESTRICTION_TYPES.MIN_LOS) {
    // Attempt to fix issue INDU-294
    if (value === 1) {
      return {
        formattedValue: intl.t(tKey('channel_pricing.restriction.none')),
        valueId: RESTRICTION_TYPE_NONE,
      };
    }

    return {
      formattedValue: intl.t(tKey('general.los'), { los: value }),
      valueId: `${RESTRICTION_TYPES.MIN_LOS}${value}`,
    };
  }

  if (type === RESTRICTION_TYPES.CLOSED) {
    if (value === 1) {
      return {
        formattedValue: intl.t(tKey('channel_pricing.restriction.closed')),
        valueId: type,
      };
    }

    // Closed 0 actually means "Close false" -> open
    if (value === 0) {
      return {
        formattedValue: intl.t(tKey('channel_pricing.restriction.none')),
        valueId: RESTRICTION_TYPE_NONE,
      };
    }
  }

  return {
    formattedValue: intl.t(tKey('general.missing')),
    valueId: intl.t(tKey('general.missing')),
  };
}
